<script>
   /**************************************************************/
   /* AppPlots component for training app                        */
   /* -------------------------------                            */
   /* show selection of plot for training of SIMCA model         */
   /**************************************************************/

   // local plot and plot controls components
   import DFPlot from '../shared/DFPlot.svelte';
   import DistancePlot from '../shared/DistancePlot.svelte';
   import ExtremePlot from '../shared/ExtremePlot.svelte';
   import AcceptancePlot from '../shared/AcceptancePlot.svelte';
   import ScoresPlot from '../shared/ScoresPlot.svelte';

   import DistancePlotControls from '../shared/DistancePlotControls.svelte';
   import ExtremePlotControls from '../shared/ExtremePlotControls.svelte';
   import AcceptancePlotControls from '../shared/AcceptancePlotControls.svelte';
   import ScoresPlotControls from '../shared/ScoresPlotControls.svelte';

   // import shared plot and plot controls components
   import AppPlots from '../shared/AppPlots.svelte';
   import SensitivityPlot from '../../../shared/plots/SensitivityPlot.svelte';
   import LoadingsPlot from '../../../shared/plots/LoadingsPlot.svelte';
   import SensitivityPlotControls from '../../../shared/plots/SensitivityPlotControls.svelte';
   import DFPlotControls from '../../../shared/plots/DFPlotControls.svelte';
   import LoadingsPlotControls from '../../../shared/plots/LoadingsPlotControls.svelte';


   // input parameters
   export let model;
   export let simcares;
   export let pcares;
   export let datasets;
   export let ncomp;

   // array with list of plots and their components
   // parameter "scope" tells parent AppPlots component whether click events must be handled:
   // - for "objects" - it triggers click events on plots as selection of objects and mark them as outliers
   // - for "variables" - it triggers click events on plots as selection of variables (no more actions so far)
   // - for "none" - the click events will be ignored
   const options = [
      {label: 'Acceptance', scope: 'objects', plotComponent: AcceptancePlot, controlsComponent: AcceptancePlotControls},
      {label: 'Distance (objects)', scope: 'objects', plotComponent: DistancePlot, controlsComponent: DistancePlotControls},
      {label: 'DoF', scope: 'none', plotComponent: DFPlot, controlsComponent: DFPlotControls},
      {label: 'Extremes', scope: 'none', plotComponent: ExtremePlot, controlsComponent: ExtremePlotControls},
      {label: 'Sensitivity', scope: 'none', plotComponent: SensitivityPlot, controlsComponent: SensitivityPlotControls},
      {label: 'Loadings', scope: 'model', plotComponent: LoadingsPlot, controlsComponent: LoadingsPlotControls},
      {label: 'Scores', scope: 'scores', plotComponent: ScoresPlot, controlsComponent: ScoresPlotControls},
   ]
</script>


<AppPlots on:setoutlier on:plotoutlier {model} {pcares} {simcares} {datasets} {options} {ncomp} />